"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTop from "./UserPageRepRepsTop";
import UserPageRepRepsTable from "./table/UserPageRepRepsTable";
import { AuthContext } from "@/components/auth/Auth";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
const TOP_REPS_COUNT = 5;
export default function UserPageRepReps(t0) {
  const $ = _c(34);
  const {
    repRates,
    profile
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const sortReps = _temp2;
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    t1 = repRates?.rating_stats ?? [];
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = sortReps(t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [reps, setReps] = useState(t2);
  const getTopReps = _temp3;
  let t3;
  if ($[4] !== reps) {
    t3 = getTopReps(reps);
    $[4] = reps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [topReps, setTopReps] = useState(t3);
  let t4;
  if ($[6] !== repRates?.rating_stats) {
    t4 = () => setReps(sortReps(repRates?.rating_stats ?? []));
    $[6] = repRates?.rating_stats;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = repRates?.rating_stats;
  let t6;
  if ($[8] !== t5) {
    t6 = [t5];
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useEffect(t4, t6);
  let t7;
  let t8;
  if ($[10] !== reps) {
    t7 = () => setTopReps(getTopReps(reps));
    t8 = [reps];
    $[10] = reps;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== activeProfileProxy || $[14] !== profile) {
    t9 = t10 => {
      const {
        myProfile,
        targetProfile
      } = t10;
      if (!myProfile?.handle) {
        return false;
      }
      if (activeProfileProxy) {
        if (profile.handle === activeProfileProxy.created_by.handle) {
          return false;
        }
        return activeProfileProxy.actions.some(_temp4);
      }
      if (myProfile.handle === targetProfile.handle) {
        return false;
      }
      return true;
    };
    $[13] = activeProfileProxy;
    $[14] = profile;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const getCanEditRep = t9;
  let t10;
  if ($[16] !== connectedProfile || $[17] !== getCanEditRep || $[18] !== profile) {
    t10 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile
    });
    $[16] = connectedProfile;
    $[17] = getCanEditRep;
    $[18] = profile;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const [canEditRep, setCanEditRep] = useState(t10);
  let t11;
  if ($[20] !== connectedProfile || $[21] !== getCanEditRep || $[22] !== profile) {
    t11 = () => {
      setCanEditRep(getCanEditRep({
        myProfile: connectedProfile,
        targetProfile: profile
      }));
    };
    $[20] = connectedProfile;
    $[21] = getCanEditRep;
    $[22] = profile;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== connectedProfile || $[25] !== profile) {
    t12 = [connectedProfile, profile];
    $[24] = connectedProfile;
    $[25] = profile;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  useEffect(t11, t12);
  let t13;
  if ($[27] !== canEditRep || $[28] !== profile || $[29] !== reps || $[30] !== topReps) {
    t13 = !!reps.length && <><div className="tw-mt-6 lg:tw-mt-8"><h3 className="tw-float-none tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Top Rep</h3></div><UserPageRepRepsTop reps={topReps} profile={profile} canEditRep={canEditRep} /><div className="tw-mt-6 lg:tw-mt-8"><h3 className="tw-float-none tw-block tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Total Rep</h3></div><UserPageRepRepsTable reps={reps} profile={profile} canEditRep={canEditRep} /></>;
    $[27] = canEditRep;
    $[28] = profile;
    $[29] = reps;
    $[30] = topReps;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <div>{t13}</div>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function _temp4(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateRep;
}
function _temp3(items_0) {
  return items_0.slice(0, TOP_REPS_COUNT);
}
function _temp2(items) {
  return [...items].sort(_temp);
}
function _temp(a, d) {
  if (a.rating === d.rating) {
    return d.contributor_count - a.contributor_count;
  }
  return d.rating - a.rating;
}